import { createFileRoute } from "@tanstack/react-router";
import { SocialEmotionalStep } from "#/modules/les.planning/components/preparation-steps";
import { socialEmotionalStepOptions } from "#/modules/les.planning/preparation-routes";

export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/lesson/$lesson/teacher/sport-participation/les/social-emotional",
)({ ...socialEmotionalStepOptions, component: Step });

function Step() {
  const navigate = Route.useNavigate();
  return (
    <SocialEmotionalStep
      data={Route.useLoaderData()}
      search={Route.useSearch()}
      onChange={(patch) =>
        void navigate({
          search: (prev) => ({ ...prev, ...patch }),
          replace: true,
          resetScroll: false,
        })
      }
    />
  );
}
